module.exports = __webpack_public_path__ + "media/images/login-hero-db08301971b701749f723024a63c51c3.png";